import jQuery from 'jquery';
import { tdDetect } from '../core/detect';
import { tdEvents } from '../core/events';
import { tdUtil } from '../core/util';
import { tdModalImageState, tdScrollState } from '../core/shared-state';
import { td_more_articles_box } from './more-articles';

declare var td_ad_background_click_link: any;
declare var td_ad_background_click_target: any;

/*
jQuery('body').click(function(e){
    if(! jQuery(e.target).hasClass('custom-background')){
        alert('clicked on something that has not the class theDIV');
    }

});*/

//click only on BACKGROUND, for devices that don't have touch (ex: phone, tablets)
if(!tdDetect.isTouchDevice && tdUtil.getBackendVar('td_ad_background_click_link') != '') {

    //var ev = ev || window.event;
    //var target = ev.target || ev.srcElement;
    jQuery('body').click(function(event) {

        //getting the target element that the user clicks - for W3C and MSIE
        // @ts-ignore
        var target = (event.target) ? event.target : event.srcElement;

        //only click on background

        var target_jquery_obj = jQuery(target);

        // td-outer-container for NEWSMAG and td-boxex-layout for NEWSPAPER
        if (target_jquery_obj.hasClass('td-outer-container') || target_jquery_obj.hasClass('td-theme-wrap') || target_jquery_obj.hasClass('td-header-wrap')) {

            //open the link ad page
            if(td_ad_background_click_target == '_blank') {
                //open in a new window
                window.open(td_ad_background_click_link);
            } else {
                //open in the same window
                location.href = td_ad_background_click_link;
            }
        }

        //e.stopPropagation();
        //stopBubble(event);
    });
}


/**
 * reading cookies
 * @param name
 * @returns {*}
 */
export function td_read_site_cookie(name) {
    var nameEQ = escape(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
    }
    return null;
}


/**
 *
 * @param td_time_cookie_array
 *
 * @param[0]: name of the cookie
 * @param[1]: value of the cookie
 * @param[2]: expiration time
 */
export function td_set_cookies_life(td_time_cookie_array) {
    var expiry = new Date();
    expiry.setTime(expiry.getTime() + td_time_cookie_array[2]);

    // Date()'s toGMTSting() method will format the date correctly for a cookie
    // @ts-ignore
    document.cookie = td_time_cookie_array[0] + "=" + td_time_cookie_array[1] + "; expires=" + expiry.toGMTString() + "; path=/";
}



















/*  ----------------------------------------------------------------------------
    Scroll to top + animation stop
 */

// Shared mutable state — exported as object property so importers can read/write it.
// Direct `export var` cannot be reassigned by importers in ES modules.
// tdScrollState is now in core/shared-state.ts — re-export for backward compatibility
var tdIsScrollingAnimation = false;
export var td_mouse_wheel_or_touch_moved = false; //we want to know if the user stopped the animation via touch or mouse move

//stop the animation on mouse wheel
jQuery(document).bind('mousewheel DOMMouseScroll MozMousePixelScroll', function(e){


    if (tdIsScrollingAnimation === false) {
        return;
    } else {

        tdIsScrollingAnimation = false;
        td_mouse_wheel_or_touch_moved = true;

        jQuery("html, body").stop();
    }
});

//stop the animation on touch
if (document.addEventListener){
    document.addEventListener('touchmove', function(e) {
        if (tdIsScrollingAnimation === false) {
            return;
        } else {
            tdIsScrollingAnimation = false;
            td_mouse_wheel_or_touch_moved = true;
            jQuery("html, body").stop();
        }
    }, false);
}

/**
 * called by tdEvents.js on scroll - back to top
 */
export var td_scroll_to_top_is_visible = false;
export function td_events_scroll_scroll_to_top(scrollTop) {
    if(tdIsScrollingAnimation) {  //do not fire the event on animations
        return;
    }
    if (scrollTop > 400) {
        if (td_scroll_to_top_is_visible === false) { //only add class if needed
            td_scroll_to_top_is_visible = true;
            jQuery('.td-scroll-up').addClass('td-scroll-up-visible');
        }
    } else {
        if (td_scroll_to_top_is_visible === true) { //only add class if needed
            td_scroll_to_top_is_visible = false;
            jQuery('.td-scroll-up').removeClass('td-scroll-up-visible');
        }
    }
}


jQuery('.td-scroll-up').click(function(){
    if(tdIsScrollingAnimation) { //double check - because when we remove the class, the button is still visible for a while
        return;
    }

    //hide the button
    td_scroll_to_top_is_visible = false;
    jQuery('.td-scroll-up').removeClass('td-scroll-up-visible');

    //hide more articles box
    td_more_articles_box.is_box_visible = false;
    jQuery('.td-more-articles-box').removeClass('td-front-end-display-block');

    //scroll to top
    tdUtil.scrollToPosition(0, 1200);

    return false;
});








// small down arrow on template 6 and full width index
jQuery('.td-read-down a').click(function(event){
    event.preventDefault();
    tdUtil.scrollToPosition(jQuery('.td-full-screen-header-image-wrap').height(), 1200);
    //tdUtil.scrollToPosition(jQuery('.td-full-screen-header-image-wrap').height() + jQuery('.td-full-screen-header-image-wrap').offset().top, 1200);
});

/**
 * make td-post-template-6 title move down and blurry
 * called from single_tempalte_6.php via the js buffer
 */
export function td_post_template_6_title() {



    //define all the variables - for better performance ?
    var td_parallax_el = document.getElementById('td_parallax_header_6');

    var td_parallax_bg_el = document.getElementById('td-full-screen-header-image');

    var scroll_from_top = '';
    var distance_from_bottom;

    //attach the animation tick on scroll
    jQuery(window).scroll(function(){
        // with each scroll event request an animation frame (we have a polyfill for animation frame)
        // the requestAnimationFrame is called only once and after that we wait
        td_request_tick();
    });


    var td_animation_running = false; //if the tick is running, we set this to true

    function td_request_tick() {
        if (td_animation_running === false) {
            window.requestAnimationFrame(td_do_animation);
        }
        td_animation_running = true;
    }

    /**
     * the animation loop
     */
    function td_do_animation() {
        // @ts-ignore
        scroll_from_top = jQuery(document).scrollTop();
        // @ts-ignore
        if (scroll_from_top <= 950) { //stop the animation after scroll from top

            // @ts-ignore
            var blur_value = 1 - (scroll_from_top / 800); // @todo trebuie verificata formula??
            if (tdDetect.isIe8 === true) {
                blur_value = 1;
            }


            blur_value = Math.round(blur_value * 100) / 100;

            //opacity
            // @ts-ignore
            td_parallax_el.style.opacity = blur_value;

            //move the bg
            // @ts-ignore
            var parallax_move = -Math.round(scroll_from_top / 4);
            tdUtil.tdMoveY(td_parallax_bg_el,-parallax_move);


            //move the title + cat
            // @ts-ignore
            distance_from_bottom = -Math.round(scroll_from_top / 8);
            tdUtil.tdMoveY(td_parallax_el,-distance_from_bottom);
            //td_parallax_el.style.bottom = distance_from_bottom + "px";  //un accelerated version


        }

        td_animation_running = false;
    }



}

//used for smart lists
export function td_smart_lists_magnific_popup() {
    //magnific popup
    jQuery(".td-lightbox-enabled").magnificPopup({
        delegate: "a",
        type: "image",
        tLoading: "Loading image #%curr%...",
        mainClass: "mfp-img-mobile",
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1],
            tCounter: tdUtil.getBackendVar('td_magnific_popup_translation_tCounter') // Markup for "1 of 7" counter
        },
        image: {
            tError: "<a href=\'%url%\'>The image #%curr%</a> could not be loaded.",
            titleSrc: function(item) {//console.log(item.el);
                //alert(jQuery(item.el).data("caption"));
                return item.el.attr("data-caption");
            }
        },
        zoom: {
            enabled: true,
            duration: 300,
            opener: function(element) {
                return element.find("img");
            }
        },
        callbacks: {
            change: function(item) {
                /**
                 * if we have pictures only on 3 from 4 slides then remove, from magnific popup, the one with no image
                 */
                //console.log(item);
                //console.log(item.el[0].id);
                //console.log(parseInt(nr_slide[1]) + 1);
                if(item.el[0].id != '') {
                    var nr_slide = item.el[0].id.split("_");

                    // Will fire when popup is closed
                    //jQuery(".td-iosSlider").iosSlider("goToSlide", this.currItem.index + 1 );
                    jQuery(".td-iosSlider").iosSlider("goToSlide", parseInt(nr_slide[1]) + 1);
                } else {
                    // @ts-ignore
                    tdModalImageState.lastEl = item.el;
                    setTimeout(function(){
                        tdUtil.scrollIntoView(item.el);
                    }, 100);
                }
            },
            beforeClose: function() {
                if (tdModalImageState.lastEl != '') {

                    tdUtil.scrollIntoView(tdModalImageState.lastEl);
                }
            }
        }
    });


    // Add video magnific popup to 'data-mpf-src' elements
    jQuery('[data-mfp-src]').on('click', function(event) {
        event.preventDefault();

        // Do nothing in TagDiv Composer
        // @ts-ignore
        if ( 'undefined' !== typeof window.parent.tdcAdminSettings ) {
            return;
        }

        var $this = jQuery( this );

        if ( ! $this.hasClass( 'td-mfp-loaded' ) ) {

            $this.addClass( 'td-mfp-loaded' );

            $this.magnificPopup({

                preloader: true,
                tLoading: "Loading url #%curr%...",
                type: "iframe",
                markup: '<div class="mfp-iframe-scaler">'+
                        '<div class="mfp-close"></div>'+
                        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                    '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
                iframe: {
                    patterns: {
                        youtube: {

                            index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                            //id: 'v=', // String that splits URL in a two parts, second part should be %id%
                            // Or null - full URL will be returned
                            // Or a function that should return %id%, for example:
                            // id: function(url) { return 'parsed id'; }

                            id: function( url ) {
                                var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]{11,11}).*/;
                                var match = url.match(regExp);
                                if (match && match.length >= 2 ) {
                                    return match[2];
                                }
                                return null;
                            },

                            src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
                        },
                        vimeo: {

                            index: 'vimeo.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                            id: '/',

                            src: '//player.vimeo.com/video/%id%?autoplay=1' // URL that will be set as a source for iframe.
                        }
                    },
                    srcAction: 'iframe_src' // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
                }
            });
        }

        $this.magnificPopup( 'open' );
    });
}





export function td_get_document_width() {
    var x = 0;
    if (self.innerHeight)
    {
        x = self.innerWidth;
    }
    else if (document.documentElement && document.documentElement.clientHeight)
    {
        x = document.documentElement.clientWidth;
    }
    else if (document.body)
    {
        x = document.body.clientWidth;
    }
    return x;
}

export function td_get_document_height() {
    var y = 0;
    if (self.innerHeight)
    {
        y = self.innerHeight;
    }
    else if (document.documentElement && document.documentElement.clientHeight)
    {
        y = document.documentElement.clientHeight;
    }
    else if (document.body)
    {
        y = document.body.clientHeight;
    }
    return y;
}


/*  ----------------------------------------------------------------------------
 Set the mobile menu min-height property

 This is usually used to force vertical scroll bar appearance from the beginning.
 Without it, on some mobile devices (ex Android), at scroll bar appearance there are some
 visual issues.

 */
export function setMenuMinHeight() {

    // @ts-ignore
    if ( 'undefined' === typeof tdEvents.previousWindowInnerWidth ) {

        // Save the previous width
        // @ts-ignore
        tdEvents.previousWindowInnerWidth = tdEvents.window_innerWidth;

    // @ts-ignore
    } else if ( tdEvents.previousWindowInnerWidth === tdEvents.window_innerWidth ) {

        // Stop if the width has not been modified
        return;
    }

    // @ts-ignore
    tdEvents.previousWindowInnerWidth = tdEvents.window_innerWidth;

    var $tdMobileMenu = jQuery( '#td-mobile-nav' ),
        cssHeight = tdEvents.window_innerHeight + 1;

    if ( $tdMobileMenu.length ) {
        $tdMobileMenu.css( 'min-height' , cssHeight + 'px' );
    }

    // Stop if we are not on mobile
    if ( ! tdDetect.isMobileDevice ) {
        return;
    }

    var $tdMobileBg = jQuery( '.td-menu-background' ),
        $tdMobileBgSearch = jQuery( '.td-search-background' );

    if ( $tdMobileBg.length ) {
        $tdMobileBg.css( 'height' , ( cssHeight + 70 ) + 'px' );
    }

    if ( $tdMobileBgSearch.length ) {
        $tdMobileBgSearch.css( 'height' , ( cssHeight + 70 ) + 'px' );
    }


}

/**
 * Used on comments form to prevent comments form submission without filing the required fields
 */

export function td_comments_form_validation() {

    //on form submit
    jQuery('.comment-form').submit( function(event) {

        jQuery('form#commentform :input').each( function() {

            var current_input_field = jQuery(this);
            var form = jQuery(this).parent().parent();

            if (current_input_field.attr('aria-required')){
                if (current_input_field.val() == '') {
                    event.preventDefault();
                    form.addClass('td-comment-form-warnings');

                    if (current_input_field.attr('id') == 'comment') {
                        form.find('.td-warning-comment').show(200);
                        current_input_field.css('border', '1px solid #ff7a7a');
                    } else if (current_input_field.attr('id') == 'author') {
                        form.find('.td-warning-author').show(200);
                        current_input_field.css('border', '1px solid #ff7a7a');
                    } else if (current_input_field.attr('id') == 'email') {
                        form.find('.td-warning-email').show(200);
                        current_input_field.css('border', '1px solid #ff7a7a');
                    }
                } else if ( current_input_field.attr('id') == 'email' && tdUtil.isEmail( current_input_field.val() ) === false ) {
                    event.preventDefault();
                    form.addClass('td-comment-form-warnings');
                    form.find('.td-warning-email-error').show(200);
                }
            }
        });

    });

    //on form input fields focus
    jQuery('form#commentform :input').each( function() {

        var form = jQuery(this).parent().parent();
        var current_input_field = jQuery(this);

        current_input_field.focus( function(){

            if (current_input_field.attr('id') == 'comment') {
                form.find('.td-warning-comment').hide(200);
                current_input_field.css('border', '1px solid #e1e1e1');

            } else if (current_input_field.attr('id') == 'author') {
                form.find('.td-warning-author').hide(200);
                current_input_field.css('border', '1px solid #e1e1e1');


            } else if (current_input_field.attr('id') == 'email') {
                form.find('.td-warning-email').hide(200);
                form.find('.td-warning-email-error').hide(200);
                current_input_field.css('border', '1px solid #e1e1e1');
            }
        });
    });
}


export function td_scroll_to_class() {
    jQuery('[data-scroll-to-class]').on('click', function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        jQuery('body').removeClass('td-menu-mob-open-menu');

        var $this = jQuery( this),
            offsetThis = $this.offset(),
            dataScrollToClass = $this.data( 'scroll-to-class' ),
            dataScrollOffset = $this.data( 'scroll-offset' ),
            dataScrollTarget = $this.data( 'scroll-target' );

        if ( 'undefined' === typeof dataScrollOffset || '' === dataScrollOffset ) {
            dataScrollOffset = 0;
        }

        if ( 'undefined' !== typeof dataScrollToClass && '' !== dataScrollToClass ) {
            var $toScrollElement = jQuery( '.' + dataScrollToClass );

            if ( tdEvents.window_innerWidth < 768 ) {
                // Timeout necessary for mobile menu transition
                setTimeout(function() {
                    td_helper_scroll_to_class( $this, $toScrollElement, offsetThis, 0, dataScrollTarget, dataScrollToClass );
                }, 500);
            } else {
                td_helper_scroll_to_class( $this, $toScrollElement, offsetThis, dataScrollOffset, dataScrollTarget, dataScrollToClass );
            }
        }
    });
}

export function td_helper_scroll_to_class( $this, $toScrollElement, offsetThis, dataScrollOffset, dataScrollTarget, dataScrollToClass ) {
    if ( $toScrollElement.length ) {
        var offsetElement = $toScrollElement.offset(),
            duration = Math.floor( Math.abs( offsetThis.top - offsetElement.top) / 100 ) * 400;

        if ( duration > 1500 ) {
            duration = 1500;
        } else if ( duration < 500 ) {
            duration = 500;
        }

        //console.log(Math.abs( offsetThis.top - offsetElement.top));
        //console.log(duration);
        tdUtil.scrollToPosition( offsetElement.top + dataScrollOffset, duration ) ;

        var $li = $this.parent().parent( 'li.menu-item' );
        if ( $li.length ) {
            $li.siblings( '.current-menu-item' ).removeClass( 'current-menu-item' );
            $li.addClass( 'current-menu-item' );
        }
        jQuery( 'body').removeClass( 'td-menu-mob-open-menu' );

    } else if ( 'undefined' !== typeof dataScrollTarget && '' !== dataScrollTarget ) {
        td_set_cookies_life(['td-cookie-scroll-to-class', dataScrollToClass, 86400000]);//86400000 is the number of milliseconds in a day
        td_set_cookies_life(['td-cookie-scroll-offset', dataScrollOffset, 86400000]);//86400000 is the number of milliseconds in a day

        jQuery( 'body').removeClass( 'td-menu-mob-open-menu' );
        window.location = dataScrollTarget;
    }
}

// @ts-ignore
jQuery(window).load(function(){

    //read the cookie
    var td_cookie_scroll_to_class = td_read_site_cookie( 'td-cookie-scroll-to-class' ),
        td_cookie_scroll_offset = td_read_site_cookie( 'td-cookie-scroll-offset' );

    if ( 'undefined' !== typeof td_cookie_scroll_to_class && null !== td_cookie_scroll_to_class ) {

        // Delete cookies
        td_set_cookies_life(['td-cookie-scroll-to-class', '', 1]);
        td_set_cookies_life(['td-cookie-scroll-offset', '', 1]);

        var $toScrollElement = jQuery( '.' + td_cookie_scroll_to_class );

        if ( $toScrollElement.length ) {
            var offsetElement = $toScrollElement.offset(),
                duration = Math.floor(Math.abs(offsetElement.top) / 100) * 400;

            if (duration > 1500) {
                duration = 1500;
            } else if (duration < 500) {
                duration = 500;
            }

            var scrollOffset = 0;
            if ( 'undefined' !== typeof td_cookie_scroll_offset && null !== td_cookie_scroll_offset ) {
                scrollOffset = parseInt( td_cookie_scroll_offset );
            }
            tdUtil.scrollToPosition(offsetElement.top + scrollOffset, duration);

            var $currentItem = jQuery('[data-scroll-to-class="' + td_cookie_scroll_to_class + '"]');
            if ( $currentItem.length ) {
                var $li = $currentItem.parent().parent('li.menu-item');
                if ($li.length) {
                    $li.siblings('.current-menu-item').removeClass('current-menu-item');
                    $li.addClass('current-menu-item');
                }
            }
        }
    }
});

export function td_smart_list_dropdown() {
    jQuery( '.td-smart-list-dropdown' ).on( 'change', function() {
        window.location.href = (this as HTMLSelectElement).value;
    });
}

export var td_fps = {

    start_time: 0,

    current_time: 0,

    frame_number: 0,

    init: function init() {
        td_fps.start_time = 0;

        var previous_result = 0,
            result = 0,
            elapsed_time = 0;

        var td_fps_table = jQuery("#fps_table");

        if (td_fps_table.length == 0) {
            td_fps_table = jQuery('<div>').css({
                "position": "fixed",
                "top": "120px",
                "left": "10px",
                "width": "100px",
                "height": "20px",
                "border": "1px solid black",
                "font-size": "11px",
                "z-index": "100000",
                "background-color": "white"
            });

            td_fps_table.appendTo('body');
        }

        var get_fps = function() {
            td_fps.frame_number++;
            td_fps.current_time = Date.now();

            elapsed_time = (td_fps.current_time - td_fps.start_time) / 1000;

            // @ts-ignore
            result = (td_fps.frame_number / elapsed_time).toPrecision(2);

            if (result != previous_result) {
                previous_result = result;
                td_fps_table.html(previous_result + ' fps');
                //console.log(previous_result);
            }

            if (elapsed_time > 1) {
                td_fps.start_time = td_fps.current_time;
                td_fps.frame_number = 0;
            }

            requestAnimationFrame(get_fps);
        };

        get_fps();
    }
};
